// src/pages/Admin/AdminDocumentation.jsx
import React, { useState } from "react";
import { Box, Button, Tabs, Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/authContext";
import NotAuthorized from "../../components/NotAuthorized/NotAuthorized";
import AdminDocumentationDocuments from "./AdminDocumentationDocuments";
import AdminDocumentationEquipment from "./AdminDocumentationEquipment";
import AdminDocumentationEmailSubscribers from "./AdminDocumentationEmailSubscribers";


const AdminDocumentation = () => {
  const [tab, setTab] = useState(0);
  const { t } = useTranslation();
  const { hasPermission } = useAuth();

  const canManageDocuments =
    hasPermission("document_management.edit_documents") ||
    hasPermission("document_management.create_documents") ||
    hasPermission("document_management.delete_documents") ||  
    hasPermission("document_management.view_documents") ||
    hasPermission("document_management.download_documents");
   

  // if (!canManageDocuments) {
  //   return <NotAuthorized />;
  // }

  const handleTabChange = (e, value) => setTab(value);

  return (
    <Box sx={{
      width: '100%',
      maxWidth: '100%',           // CRITICAL: Prevent expansion
      overflow: 'hidden',          // CHANGED: from 'auto' to 'hidden'
      boxSizing: 'border-box'      // ADDED: Proper box sizing
    }}>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        sx={{ 
          borderBottom: "1px solid #eee", 
          mb: 2,
          width: '100%',             // ADDED: Constrain tabs
          maxWidth: '100%'           // ADDED: Prevent tabs overflow
        }}
      >
        <Tab label={t('ADMIN.DOCUMENTS')} />
        <Tab label={t('ADMIN.EQUIPMENT')} />
        <Tab label={t('ADMIN.EMAIL_SUBSCRIBERS')} />
      </Tabs>

      {/* Wrap tab content in constrained container */}
      <Box sx={{
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}>
        {tab === 0 && <AdminDocumentationDocuments />}
        {tab === 1 && <AdminDocumentationEquipment />}
        {tab === 2 && <AdminDocumentationEmailSubscribers />}
      </Box>
    </Box>
  );
};

export default AdminDocumentation;
